<template>
  <section v-if="items.length">
    <v-container>
      <TitleWidget> {{ title }} </TitleWidget>

      <div class="mt-8 mt-md-10 justify-center grid-list">
        <BrandCard
          v-for="(item, keyItems) in items"
          :key="keyItems"
          v-bind="item"
        />
      </div>
    </v-container>
  </section>
</template>

<script>
import TitleWidget from "../widgets/TitleWidget.vue";
import BrandCard from "../cards/BrandCard.vue";

const _config = {
  mod: "brands",
};

const _data = {
  title: "ESPECIALIZADO NAS MARCAS:",
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    items() {
      return this.$rest(_config.mod).list.filter(
        ({ featured }) => featured === 1
      );
    },
  },
  created() {
    this.$rest(_config.mod).get();
  },
  components: {
    TitleWidget,
    BrandCard,
  },
};
</script>

<style lang="scss" scoped>
.grid-list::v-deep {
  display: grid;
  gap: 30px;
  grid-template-columns: repeat(auto-fit, minmax(auto, 180px));

  @media screen and (max-width: 599.9px) {
    grid-template-columns: 1fr 1fr;
  }
}
</style>
